import {
  createResource,
  getResource
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const GET_CATEGORY = prefixAPI('category-list/')
export const GET_LIST = prefixAPI('file-list/')
export const DOWNLOAD_FILE = '/download/'
export const DOWNLOAD_ARCHIVE = '/download-zip/'

export const categoryResource = createResource(GET_CATEGORY, getResource)
export const filesResource = createResource(GET_LIST, getResource)





// WEBPACK FOOTER //
// ./src/js/services/downloading.js